import Bridge from "@/utils/bridge";

export function clientBrowser() {
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //ios
    return "ios";
  } else if (/(Android)/i.test(navigator.userAgent)) {
    //android
    return "android";
  }
}

// 获取token
export function handleToken() {
  return new Promise((resolve) => {
    const client = clientBrowser();
    // 本地开发时，设置token，并取消注释
    // resolve(
    //   "eyJhbGciOiJIUzUxMiJ9.eyJ1c2VyaWQiOiI2MTgiLCJsb2dpbl91c2VyX2tleSI6ImZjNzk5NDJmLTNjNzktNDcyYy05ZTFjLWI0ZmMyY2YzMmM1OCJ9.OGu6rzLRndsHT73AAEZQoV4RhgSz2yMqfgbeTvMHrGy6rmFf3KLAuWnhAoUHAgnQUqpa9Ij93rM08PLj5G_mdw"
    // );
    if (client == "ios") {
      Bridge.callhandler("getIosToken", {}, (token) => {
        resolve(token);
      });
    } else if (client == "android") {
      if (window.LoanMarketChina) {
        let token = window.LoanMarketChina.getAuthorization();
        resolve(token);
      }
    }
  });
}

export function judgeBrand() {
  let sUserAgent = navigator.userAgent.toLowerCase();
  let isIphone = sUserAgent.match(/iphone/i) == "iphone";
  let isHuawei = sUserAgent.match(/huawei/i) == "huawei";
  let isHonor = sUserAgent.match(/honor/i) == "honor";
  let isOppo = sUserAgent.match(/oppo/i) == "oppo";
  let isOppoR15 = sUserAgent.match(/pacm00/i) == "pacm00";
  let isVivo = sUserAgent.match(/vivo/i) == "vivo";
  let isXiaomi = sUserAgent.match(/mi\s/i) == "mi ";
  let isXiaomi2s = sUserAgent.match(/mix\s/i) == "mix ";
  let isRedmi = sUserAgent.match(/redmi/i) == "redmi";
  let isSamsung = sUserAgent.match(/sm-/i) == "sm-";

  if (isIphone) {
    return "iphone";
  } else if (isHuawei || isHonor) {
    return "huawei";
  } else if (isOppo || isOppoR15) {
    return "oppo";
  } else if (isVivo) {
    return "vivo";
  } else if (isXiaomi || isRedmi || isXiaomi2s) {
    return "xiaomi";
  } else if (isSamsung) {
    return "samsung";
  } else {
    return "default";
  }
}
